module.exports = __webpack_public_path__ + "static/media/NA.9303a869.svg";